module.exports = __webpack_public_path__ + "img/tech-maniac.4b81adf6.png";